<template>
  <div class="bottomBarNavigation">

    <router-link to="/scan" class="controls_icon" v-if="!showPicture">
      <span class="icon icon-white icon-scan icon-md" :class="{'current':currentRoute==='scan'}"></span>
      <!--      <font-awesome-icon size="lg" :color="currentRoute==='scan' ? '#00d6ff':'#fff'" icon="qrcode"/>-->
    </router-link>

    <!--    <router-link to="/camera" class="controls_icon" v-if="currentRoute==='scan'" >-->
    <!--      <font-awesome-icon size="lg"   :color="currentRoute==='camera' ? '#00d6ff':'#000'" icon="camera"/>-->
    <!--    </router-link>-->
    <!--    <font-awesome-icon class="hideFilters" icon="times" size="lg" color="#000" v-if="showFilters && currentRoute==='camera'" @click="hideFilter"/>-->

    <!--    <div class="controls_icon" @click="showFilter" v-if="!showFilters && currentRoute==='camera'">-->
    <!--      <font-awesome-icon size="lg"  :color="showFilters ? '#00d6ff':'#000'"  class="" icon="theater-masks"/>-->
    <!--    </div>-->

    <router-link to="/profile" class="controls_icon" v-if="!showPicture">
      <span class="icon icon-white icon-profil icon-md" :class="{'current':listProfil.includes(currentRoute)}"></span>
      <!--      <font-awesome-icon size="lg" :color="currentRoute==='profile' ? '#00d6ff':'#fff'" icon="user"/>-->
    </router-link>

    <router-link to="/camera" class="controls_icon" v-if="!showPicture">
      <span class="icon icon-white icon-camera icon-md" :class="{'current':currentRoute==='camera'}"></span>
      <!--      <font-awesome-icon size="lg" :color="currentRoute==='camera' ? '#00d6ff':'#fff'" icon="camera"/>-->
    </router-link>

    <router-link to="/gallerie" class="controls_icon" v-if="!showPicture">
      <span class="icon icon-white icon-picture icon-md" :class="{'current':currentRoute==='gallerie'}"></span>
      <!--      <font-awesome-icon size="lg" :color="currentRoute==='gallerie' ? '#00d6ff':'#fff'" icon="clone"/>-->
    </router-link>

    <span v-if="showPicture" @click="cancelPicture" class="picture-action cancel-picture">
      <font-awesome-icon size="lg" color="#FF3333FF" icon="times"/>
    </span>
    <span v-if="showPicture" @click="saveImg" class="picture-action save-picture">
      <font-awesome-icon size="lg" color="#FFF" icon="save"/>
    </span>
    <span v-if="showPicture" @click="sharePicture" class="picture-action share-picture">
            <font-awesome-icon size="lg" color="#FFF" icon="share-square"/>
    </span>
    <router-link to="/settings" class="header_element" v-if="!showPicture">
      <span class="icon icon-white icon-cog icon-md" :class="{'current':currentRoute==='settings'}"></span>
      <!--      <font-awesome-icon size="lg" :color="currentRoute==='settings' ? '#00d6ff':'#fff'"  icon="cog"/>-->
    </router-link>
  </div>

</template>

<script>
import {store} from '../../../store/store';
import {mapState, mapActions} from "vuex";
import PopUp from "../../Modals/Modal";


export default {
  name: 'BottomBarNavigation',
  components: {
    PopUp
  },
  props: {},
  data() {
    return {
      currentRoute: this.$route.name,
      listProfil: [
        'profile',
        'collection',
        'trophies',
        'listscan',
        'ranking'
      ]

    }
  },
  watch: {
    $route(to, from) {
      this.currentRoute = to.name;
    }
  },
  mounted() {
    // document.querySelector('.jeeFaceFilterCanvas').style.display="block";
    // main()
  },
  computed: {
    ...mapState([
      "user",
      "showFilters",
      "showPicture",
      "currentMedia"
    ])
  },

  methods: {
    ...mapActions(['addPicture', 'sharedPicture', 'getSuccess']),
    cancelPicture() {
      store.state.showPicture = false
      store.state.currentMedia = ''
      document.querySelector('#jeeFaceFilterCanvas').style.display = "block";

    },
    saveImg() {
      if (this.currentMedia.duplicate > 0) {
        this.addPicture(this.currentMedia).then(res => {
          store.state.successBase = res.successList.filter(function (el) {
            return el.condition === null
          })
          store.state.success = res.successList.filter(function (el) {
            return el.condition != null
          })
          store.state.showPicture = false
          store.state.currentMedia = ''
        })
      } else {
        alert('PAS DE MASQUE')
      }
      document.querySelector('#jeeFaceFilterCanvas').style.display = "block";

    },
    sharePicture() {
      let canvas = this.currentMedia.canvas
      let order = this.currentMedia.order
      canvas.toBlob(async (blob) => {
        const files = [new File([blob], 'image.png', {type: blob.type})]
        const shareData = {
          text: 'Animhead',
          title: 'Animhead',
          files,
        }
        window.navigator.share(shareData)
            .then(() => {
              if (this.currentMedia.duplicate > 0) {
                let pictID = null
                this.addPicture(this.currentMedia).then(res => {
                  store.state.successBase = res.successList.filter(function (el) {
                    return el.condition === null
                  })
                  store.state.success = res.successList.filter(function (el) {
                    return el.condition != null
                  })
                  pictID = res.p
                })

                this.sharedPicture(pictID).then(res => {
                  store.state.successBase.push(...res.successList.filter(function (el) {
                    return el.condition === null
                  }))
                  store.state.success.push(...res.successList.filter(function (el) {
                    return el.condition != null
                  }))
                  store.state.showPicture = false
                  store.state.currentMedia = ''
                })

                document.querySelector('#jeeFaceFilterCanvas').style.display = "block";
              } else {
                alert('Aucun Masque dupliqué')
              }

            })
            .catch(error => console.log("error", error))

      })
    }
  }
}

</script>

<style>
.bottomBarNavigation {
  background-color: #297F9E;
  border-top: 4px solid #297F9E;
  display: flex;
  width: 100%;
  position: fixed;
  bottom: 0;
  justify-content: space-evenly;
  align-items: center;
}

.picture-action {
  /*border-top: 4px solid #ff3333;*/
  font-size: initial;
}

/*.bottomBarNavigation > * {*/
/*  margin: 0 25px;*/
/*}*/

@media screen and (max-width: 750px) {
  .bottomBarNavigation {
    z-index: 2;
    padding: 5px 0;
    padding-bottom: calc(10px + env(safe-area-inset-bottom));
  }
}

</style>
